import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import { Message, Label, Loader } from 'oxyrion-ui/lib';
import { Toggle, ToggleItem } from 'oxyrion-ui/lib/Toggle';
import { ErrorWrapper } from '../../Components/ReusableComponents';
import { __, formatColorToRGB, getHighlightedText } from '../../Utils';
import SearchableLazyLoadingSelect from '../../Components/SearchableLazyLoadingSelect';
import API2 from '../../API2';

const Wrapper = styled.div`
  z-index: 3;
`;

const CardName = styled.div``;

const SearchableSelectWrapper = styled.div`
  width: ${rem(400)};
  margin-bottom: ${rem(16)};
`;

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(12)};
  @media (min-width: 1500px) {
    flex-direction: row;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  font-size: 12px;
  align-items: center;
`;

const ColorcardLabel = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const CardSubWrapper = styled.div``;

const CardPurpose = styled.div`
  font-size: ${rem(12)};
  color: #c7c7c7;
`;

const ColorRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 365px;
`;

const ColorName = styled.div``;

const ColorHolder = styled.div`
  background: ${props => props.color};
  width: ${rem(64)};
  height: ${rem(32)};
`;

const NameAndBaseWrapper = styled.div``;

const Base = styled.div`
  font-size: ${rem(12)};
  color: #c7c7c7;
`;

const Space = styled.div`
  width: ${rem(12)};
  height: ${rem(12)};
`;

const Counts = styled.div``;

class SecondStep extends React.PureComponent {
  state = {
    error: false,
    selectedColorCard: null,
    selectedType: 'shade',
  };

  componentDidMount() {
    const { colorcardId, colorId, shadeBases, callback } = this.props;

    if (colorcardId && colorId && shadeBases) {
      this.setState({
        defaultSearchText: colorId,
        selectedType: 'shade',
      });

      callback(
        {
          _id: colorcardId,
          purpose: 'tinting',
        },
        {
          color_code: colorId,
          basecodes: shadeBases,
        },
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.productId && !this.props.productId) {
      this.setState({
        error: false,
        selectedColorCard: null,
        selectedShade: null,
        selectedType: 'colorcard',
      });
    }
  }

  fetchShades(query, limit, offset) {
    const { selectedColorCard, selectedType } = this.state;
    const { bases } = this.props;

    if (!this.props.productId) {
      return [];
    }

    const params = { q: query, limit, offset };

    if (selectedColorCard && selectedColorCard.value) {
      params.colorcardId = selectedColorCard.value;
    }

    if (
      selectedColorCard &&
      selectedColorCard.value &&
      selectedColorCard.raw.purpose === 'finished'
    ) {
      params.onlyFinishedUsedShades = true;
    }

    if (!selectedColorCard && selectedType === 'colorcard') {
      return {
        options: [],
        next_offset: 0,
      };
    }

    return API2.getB2BCatalogProductShadesAction(
      this.props.productId,
      params,
    ).then(res => {
      return {
        next_offset: res.next_offset,
        options: res.shades.map(item => ({
          value: item.color_code,
          fullName: item.color_base_name || item.color_code,
          label: (
            <ColorRow>
              <NameAndBaseWrapper>
                <ColorName>
                  {getHighlightedText(
                    item.color_base_name || item.color_code,
                    query,
                  )}
                </ColorName>
                <Base>
                  {`${__('Báza:')} ${item.basecodes
                    .filter(b => bases.indexOf(b) > -1)
                    .join(',')}`}
                </Base>
              </NameAndBaseWrapper>
              <ColorHolder color={formatColorToRGB(item.color)} />
            </ColorRow>
          ),
          raw: item,
        })),
      };
    });
  }

  fetchColorcards(query, limit, offset) {
    if (!this.props.productId) {
      return [];
    }
    try {
      return API2.getB2BCatalogProductColorcardsAction(this.props.productId, {
        removeDupliciteShades: true,
        q: query,
        limit,
        offset,
      }).then(res => {
        return {
          next_offset: res.next_offset,
          options: res.cards.map(item => ({
            value: item._id,
            shades: item.shades,
            raw: item,
            fullName: item.base_name || item.name,
            label: (
              <ColorcardLabel>
                <CardSubWrapper>
                  <CardName>
                    {getHighlightedText(item.base_name || item.name, query)}
                  </CardName>
                  <CardPurpose>
                    {item.purpose === 'tinting'
                      ? __('Tónované odtiene')
                      : __('Hotové odtiene')}
                  </CardPurpose>
                </CardSubWrapper>
                <Counts>{item.shades.length}</Counts>
              </ColorcardLabel>
            ),
          })),
        };
      });
    } catch (e) {
      return [];
    }
  }

  handleColorcardChange(e) {
    let { selectedColorCard, selectedShade } = this.state;

    if (e) {
      selectedColorCard = e;
    } else {
      selectedColorCard = null;
      this.props.resetNextSteps();
    }

    selectedShade = null;

    this.setState({ selectedColorCard, selectedShade });
  }

  handleShadeChange(e) {
    let { selectedShade } = this.state;
    const { callback } = this.props;

    if (e) {
      selectedShade = e;
    } else {
      selectedShade = null;
      this.props.resetNextSteps();
      return;
    }

    this.setState({ selectedShade }, () => {
      callback(
        {
          _id: selectedShade.raw.colorcard_id,
          purpose: selectedShade.raw.colorcard_purpose, // tu toto upravit
        },
        selectedShade.raw,
      );
    });
  }

  async handleTypeChange(value) {
    const { selectedShade } = this.state;

    if (value === 'colorcard' && selectedShade) {
      try {
        const item = await API2.getB2BColorcardAction(
          selectedShade.raw.colorcard_id,
        );

        this.setState({
          selectedType: value,
          selectedColorCard: {
            value: item._id,
            shades: item.shades,
            raw: item,
            label: (
              <ColorcardLabel>
                <CardName>{item.name}</CardName>
                <CardSubWrapper>
                  <CardPurpose>
                    {item.purpose === 'tinting'
                      ? __('Tónované odtiene')
                      : __('Hotové odtiene')}
                  </CardPurpose>
                  {/* <Counts>{item.shades.length}</Counts> */}
                </CardSubWrapper>
              </ColorcardLabel>
            ),
          },
        });
      } catch (e) {
        console.log(e);
      }
    } else {
      this.setState({
        selectedType: value,
        selectedColorCard: null,
      });
    }
  }

  render() {
    const {
      error,
      selectedColorCard,
      selectedType,
      defaultSearchText,
    } = this.state;

    const { productId, loading } = this.props;

    if (error) {
      return (
        <ErrorWrapper>
          <Message error message={error} />
        </ErrorWrapper>
      );
    }

    return (
      <Wrapper>
        <Toggle
          style={{
            width: rem(325),
          }}
          name="type"
          onClick={() =>
            this.handleTypeChange(
              selectedType === 'colorcard' ? 'shade' : 'colorcard',
            )
          }
        >
          <ToggleItem
            checked={selectedType === 'shade'}
            value="shade"
            label={__('Odtieň')}
          />
          <ToggleItem
            checked={selectedType === 'colorcard'}
            value="colorcard"
            label={__('Vzorkovník')}
          />
        </Toggle>
        <SearchWrapper>
          {selectedType === 'colorcard' && (
            <SearchableSelectWrapper>
              <Label>{__('Vzorkovník')}</Label>
              <SearchableLazyLoadingSelect
                placeholder={__('Vyhľadať vzorkovník')}
                fetchData={(q, l, o) => this.fetchColorcards(q, l, o)}
                keyProps={`key__${JSON.stringify({ productId, selectedType })}`}
                disabled={loading}
                openOnLoad
                onSelect={e => this.handleColorcardChange(e)}
                limit={20}
              />
            </SearchableSelectWrapper>
          )}
          {selectedType === 'colorcard' && <Space />}
          <SearchableSelectWrapper>
            <Label>{__('Odtieň')}</Label>
            <SearchableLazyLoadingSelect
              placeholder={__('Vyhľadať odtieň')}
              fetchData={(q, l, o) => {
                return this.fetchShades(q, l, o);
              }}
              keyProps={`key__${JSON.stringify({
                selectedColorCard: selectedColorCard && selectedColorCard.value,
                purpose:
                  selectedColorCard &&
                  selectedColorCard.raw &&
                  selectedColorCard.raw.purpose,
                selectedType,
                productId: this.props.productId,
              })}`}
              disabled={
                (!selectedColorCard && selectedType === 'colorcard') || loading
              }
              defaultSearchText={defaultSearchText}
              onSelect={e => this.handleShadeChange(e)}
              limit={30}
              treshold={0.6}
            />

            {loading && (
              <LoadingWrapper>
                <Loader />
                <Space />
                {__('Prebieha prepočet cien')}
              </LoadingWrapper>
            )}
          </SearchableSelectWrapper>
        </SearchWrapper>
      </Wrapper>
    );
  }
}
SecondStep.propTypes = {
  history: PropTypes.shape({}).isRequired,
  firm: PropTypes.string,
  productId: PropTypes.string,
  callback: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  resetNextSteps: PropTypes.func,
  bases: PropTypes.arrayOf({}),
};

SecondStep.defaultProps = {
  firm: 'SK',
  productId: null,
  loading: false,
  resetNextSteps: () => {},
  bases: [],
};

export default SecondStep;



// WEBPACK FOOTER //
// ./src/Containers/Toning/secondStep.jsx